import * as ads from "./ads";
import match from "./match.js";
import prematch from "./prematch.js";
import moment from "moment";

export default {
  ...match,
  ...prematch,
  [ads.CATEGORY]: ads.getters,
  isAuth: (state) => {
    return Boolean(state.user);
  },
  // A-10: проверка права. Источник — permissions авторизованного юзера,
  // либо права статуса guest для неавторизованного.
  hasPermission:
    (state) =>
    (key) => {
      const perms = state.user
        ? state.user.permissions || []
        : state.guestPermissions || [];
      return perms.includes(key);
    },
  gerUser: (state) => {
    if (!state.user) return state.user;
    return (
      {
        ...state.user,
        devices: {
          ...state.user.devices.map(
            ({ id, name, active = false, updatedAt }) => ({
              id,
              name,
              active,
              lastActivity: updatedAt
                ? moment(updatedAt).format("DD.MM.YYYY HH:mm")
                : "",
            }),
          ),
        },
      } || false
    );
  },
  isDarkTheme: (state) => state.isDarkTheme,
  filterCategory: () => (route) =>
    route.name.replace(" ", "").toLocaleLowerCase(),
  subscription: (state) =>
    state.subscription.list
      ? state.subscription.list.sort((a, b) => a.price - b.price)
      : null,
};
